import { create as _create } from '@thoughtspot/logger';
const APP_NAME = 'TS-App-Admin';
export const create = (moduleName) => _create(`${APP_NAME}-${moduleName}`);
export { LogLevel } from '@thoughtspot/logger';
//# sourceMappingURL=index.js.map